module.exports = __webpack_public_path__ + "static/media/MultisegmentalFlexionMale.c3eaafc2.svg";